<template>
    <div class="animated fadeIn">
        <b-card header-tag="header">
            <div slot="header">
                <i class="icon-people"></i> Usuários
                <b-link :to="`/platform/users/`" class="btn mr-2 btn-sm btn-primary float-right">
                <i class="fa fa-angle-left"></i>
                  Voltar
                </b-link>
            </div>
            <b-card-body>
                <div class="alert alert-danger" role="alert" v-show="hasError">{{errorMessage}}</div>
                <form @submit.prevent="validate" class="needs-validation" novalidate>
                    <user-input v-model="model" :action="action" />                
                    <button type="submit" class="btn btn-primary">Salvar</button>
                </form>
            </b-card-body>
        </b-card>
    </div>
</template>
<script>
import userInput from '../../../components/customers/userInput.vue'
import userService from '../../../services/Customer/userService'
import editPage from '../../../mixins/editPage'
export default {
    components: { userInput },
    props: {
        id: String
    },
    mixins: [editPage],
    data() {
        return {
            resetPasswordMessage: '',
            showResetPassword: false,
            model: {
                firstName: '',
                lastName: '',
                email: '',
                phone: {
                    areaCode: '',
                    number: ''
                },
                id: '',
                customerId: '',
                role: '',
                blocked: false
            }
        }
    },
    computed: {
        action() {
            return this.$route.name
        }
    },
    created(){
        this.fetchUserData()
    },
    methods: {
        fetchUserData() {
            if(this.action == 'edit_admin') {
                const self = this
                self.showLoading()
                userService.find(this.id).then((response) =>{
                    self.model = response.data
                    self.hideLoading()
                }, () => {
                    self.hideLoading()
                })
            }
        },
        validate() {
            const self = this
            self.showLoading()
            this.$validator.validateAll().then(isValid => {
                if (isValid) {
                    self.model.customerId = self.$auth.customerId
                    if(this.action == 'new_admin') {
                        userService.createUser(self.model).then(() => {
                            self.hideLoading()
                            self.$router.push({ path:'/platform/users'})
                        },
                        error => {
                            self.showError(error.response.data.message)
                            self.hideLoading()
                        })
                    }
                    else {
                        userService.updateUser(self.model).then(() => {
                            self.hideLoading()
                            self.$router.push({ path:'/platform/users'})
                        },
                        error => {
                            self.showError(error.response.data.message)
                            self.hideLoading()
                        })
                    }
                    
                } 
                else 
                {
                    self.hideLoading()
                }
            })
        }        
    }
}
</script>
